import NextImage from '@com/_core/NextImage';
import { colorPallete } from '@configs/color-pallete';
import { BookingHeaderProfile, UserServiceItem } from '@models/clinic-list';
import Icon from '@utilities/icon';

type BookingHeaderProps = {
  profile: BookingHeaderProfile;
  service?: UserServiceItem;
};

const DEFAULT_CLINIC_IMAGE = '/images/ocs/images/profile.svg';

const BookingHeader = ({ profile, service }: BookingHeaderProps) => {
  const address = profile.addresses?.[0]?.address;

  return (
    <div className="mt-2 px-4">
      <div className="flex items-center gap-x-2">
        <div className="relative shrink-0">
          <div className="flex h-14 w-14 items-center justify-center overflow-hidden rounded-full border border-surface-tertiary">
            <NextImage
              src={profile?.basicInfo?.coverImageUrl ?? DEFAULT_CLINIC_IMAGE}
              alt={profile?.basicInfo?.fullName}
              width={56}
              height={56}
            />
          </div>
        </div>
        <div className="flex min-w-0 flex-col">
          <span className="truncate text-Label/xSmall text-content-primary">
            {profile?.basicInfo?.fullName}
          </span>
          {!!service?.serviceHierarchyName && (
            <span className="truncate text-Label/xSmall text-content-tertiary">
              {service?.serviceHierarchyName}
            </span>
          )}
        </div>
      </div>

      {address && (
        <div className="flex min-w-0 items-center gap-x-1 mt-2">
          <Icon
            name="PinCircle"
            width={1}
            height={1}
            fill={colorPallete?.content?.tertiary}
          />
          <span className="truncate text-Label/2xSmall text-content-tertiary">
            {address}
          </span>
        </div>
      )}
    </div>
  );
};

export default BookingHeader;
